import React from 'react'

import { IAgreementData } from './agreements.interface'

type AgreementContextProps = {
  receivedData: Array<IAgreementData>
  setReceivedData: (data: Array<IAgreementData>) => void
  collectiveAgreements: any
  setCollectiveAgreements: (data: any) => void
  modifiedAgreements: string[]
  setModifiedAgreements(agreementId: string): void
}

const AgreementContext = React.createContext<AgreementContextProps>({
  receivedData: [],
  setReceivedData: () => {},
  modifiedAgreements: [],
  setModifiedAgreements: () => {},
  collectiveAgreements: {},
  setCollectiveAgreements: () => {},
})

export const AgreementProvider = AgreementContext.Provider
export const AgreementConsumer = AgreementContext.Consumer
export default AgreementContext
